var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-app-bar-nav-icon',_vm._g({staticClass:"nav-logout ma-0",attrs:{"width":"24","height":"24","tile":""},domProps:{"innerHTML":_vm._s(require(`@/assets/img/icons/logout.svg`))},on:{"click":_vm.unAuth}},on))]}}])},[_c('span',[_vm._v("Выход")])])
}
var staticRenderFns = []

export { render, staticRenderFns }